import * as React from 'react';
import { SetterOrUpdater, useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import DistanceWidget from './widgets/DistanceWidget';
import SpeedWidget from './widgets/SpeedWidget';
import EventsWidget from './widgets/EventsWidget';
import EcoScoreWidget from './widgets/EcoScoreWidget';
import DatePlaceWidget from './widgets/DatePlaceWidget';
import { IRide } from './types';
import { activeRideNumberAtom } from './RidePlayerState';
import useAnalytics from '../../hooks/useAnalytics';

interface ILastRidePanelProps {
  rides: IRide[];
  setIsRidePlayerOpen?: SetterOrUpdater<number | boolean>;
}

function LastRidePanel(props: ILastRidePanelProps): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const activeRideNumber = useRecoilValue(activeRideNumberAtom);

  const handleClose = () => {
    if (props.setIsRidePlayerOpen) {
      trackEvent(['Ride Player', 'click', 'Close ride player']);
      props.setIsRidePlayerOpen(false);
    } else {
      trackEvent(['Ride Player', 'click', 'Close ride player window']);
      // window.close() doesn't work, if new window has not been opened by current browser
      window.close();
    }
  };

  return (
    <div className="w-map w-map--wrapper">
      <div className="w-map">
        <div className="b-widgets-info" style={{ overflow: 'inherit' }}>
          <div className="b-tabs-toggler">
            <ul>
              <li className="active">
                <a href="#" style={{ width: 'auto', overflow: 'hidden' }}>
                  {`${
                    props.rides[activeRideNumber - 1]
                      ? `${
                          props.rides[activeRideNumber - 1].rideData.licenceNumber
                            ? `${props.rides[activeRideNumber - 1].rideData.licenceNumber} `
                            : ''
                        } ${
                          props.rides[activeRideNumber - 1].rideData.driverName
                            ? `${props.rides[activeRideNumber - 1].rideData.driverName}`
                            : ''
                        }`
                      : ''
                  }`}
                </a>
              </li>
              <li className="tab-actions" />
              <li className="tab-actions">
                <a
                  href="#"
                  className="cmd-icon cmd-icon-remove-sm"
                  onClick={handleClose}
                  title={f({ id: 'ridePlayer.button.close.tooltip' })}
                >
                  {/* &nbsp; */}
                </a>
              </li>
            </ul>
          </div>
          <div className="b-widgets-info-tab-content">
            <div
              className="b-widget-grid b-widget-grid--rounded b-widget-grid--static"
              style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}
            >
              <DatePlaceWidget rides={props.rides} />
              <div className="item" />
              <div className="item" />
              <SpeedWidget rides={props.rides} />
              <EcoScoreWidget rides={props.rides} />
              <DistanceWidget rides={props.rides} isLastRidePlayer={true} />
              <EventsWidget rides={props.rides} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LastRidePanel;
